export const storeConnectionError = {
  es: {
    title: 'Error de conexión con la tienda',
    message: 'No hemos podido conectar con la tienda en este momento. Por favor, inténtalo de nuevo más tarde.',
  },
  en: {
    title: 'Store connection error',
    message: 'We were unable to connect to the store at this time. Please try again later.',
  },
  fr: {
    title: 'Erreur de connexion avec le magasin',
    message: "Nous n'avons pas pu nous connecter au magasin pour le moment. Veuillez réessayer plus tard.",
  },
  it: {
    title: 'Errore di connessione con il negozio',
    message: 'Non siamo riusciti a connetterci al negozio in questo momento. Per favore riprova più tardi.',
  },
  pt: {
    title: 'Erro de conexão com a loja',
    message: 'Não foi possível conectar à loja neste momento. Por favor, tente novamente mais tarde.',
  },
  de: {
    title: 'Verbindungsfehler mit dem Shop',
    message: 'Wir konnten derzeit keine Verbindung zum Shop herstellen. Bitte versuchen Sie es später erneut.',
  },
  nl: {
    title: 'Verbindingsfout met de winkel',
    message: 'We konden op dit moment geen verbinding maken met de winkel. Probeer het later opnieuw.',
  },
  ko: {
    title: '매장 연결 오류',
    message: '현재 매장에 연결할 수 없습니다. 나중에 다시 시도해 주세요.',
  },
}
